module.exports = "<div class=\"overlay\">\n  <section class=\"dialog-box zui-bgcolor-white\">\n    <div class=\"icon close customClose\" (click)=\"closePrompt()\"></div>\n    <ng-content></ng-content>\n  </section>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/user-info/user-info.component.html
// module id = ./src/app/components/user-info/user-info.component.html
// module chunks = main